import React from "react";

import HealtheraTable from "../../../Table/Table";

import { convertClinicsToTable, prepareLoadingData } from "./table";

const Clinics = ({
  clinics,
  onRowsPerPageChange,
  onPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  total,
  isLoading,
}) => {
  const preparedData = isLoading
    ? prepareLoadingData(rowsPerPage)
    : convertClinicsToTable(clinics);

  return (
    <HealtheraTable
      isLiveDashboard={false}
      data={preparedData}
      totalCount={total}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onChangePage={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      page={page}
      displayPagination
    />
  );
};

export default Clinics;
